import { render, staticRenderFns } from "./BindsDropDownIcon.vue?vue&type=template&id=021ca7cc&"
import script from "./BindsDropDownIcon.vue?vue&type=script&lang=js&"
export * from "./BindsDropDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports